import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {TapHandler} from '../../tap-handler/tap-handler.component';
import {Check} from '@sparkware/app-utils';
import {AnyStyledComponent} from 'styled-components';
import styled from 'styled-components';

interface LinkProps {
  box?: AnyStyledComponent;
  id?: string;
  onClick?: (event?: any) => void;
  className?: string;
  href?: string;
  enableTap?: boolean;
  preventDefaultOnClick?: boolean
  target?: string;
  itemProp?: string;
  customProps?: {[key: string]: any};
}

const DefaultBox = styled.a`
  color: ${props => props.theme.colors.text};
`;

export class Link extends OrbitComponent<LinkProps> {

  private _onClick = (event) => {

    if (this.services.miniOrbit.isEnabled && this.props.target === "_blank") {
      event.preventDefault();
      this.services.miniOrbit.openUrl(this.props.href);

    } else if (Check.isNullOrUndefined(this.props.preventDefaultOnClick) || this.props.preventDefaultOnClick) {
      event.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  private _getAnchorProps(): any {
    let result: any = {};

    if(this.props.id) {
      result.id = this.props.id;
    }
    if(this.props.className) {
      result.className = this.props.className;
    }

    if(this.props.href) {
      result.href = this.services.location.buildFullUri(this.props.href || '/').toString();
    }

    if(this.props.target) {
      result.target = this.props.target;
    }

    if(this.props.itemProp) {
      result.itemProp = this.props.itemProp;
    }

    if (this.props.customProps) {
      result.customProps = this.props.customProps;
    }

    return result;
  }

  private _renderAnchor(anchorRef: any) {
    const Box = this.props.box || DefaultBox;
    return (
      <Box {...this._getAnchorProps()}
         onClick={this._onClick}
         ref={anchorRef}>
        {this.props.children}
      </Box>
    );
  }

  render() {
    if (!this.props.enableTap) {
      return this._renderAnchor(null);
    }

    let anchorRef: any = React.createRef();
    return (
      <TapHandler enabled={this.props.enableTap} elementRef={anchorRef}>
        {this._renderAnchor(anchorRef)}
      </TapHandler>
    );
  }
}
